export default {
  "login": {
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["e-Posta"])}
  },
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])}
}